import { ReactNode, useMemo } from "react";
import { useAccess } from "../../access/useAccess";
import type { Clause, Policy, Scope } from "../../access/policy";


export default function AccessGate({
  anyOf, allOf, scope = "any", fallback = null, children, or,
}: {
  anyOf?: string[]; allOf?: string[]; scope?: Scope; fallback?: ReactNode; children: ReactNode; or?: Clause[];
}) {
  const { canAccess } = useAccess();
  const policy: Policy = useMemo(
    () => (or?.length ? { or } : { rolesAnyOf: anyOf, rolesAllOf: allOf, roleScope: scope }),
    [or, anyOf, allOf, scope]
  );
  return canAccess(policy, scope) ? <>{children}</> : <>{fallback}</>;
}
